import { Injectable } from '@angular/core';

export type ThemeMode = 'light' | 'dark';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  private readonly THEME_STORAGE_KEY = 'theme-mode';
  private readonly DEFAULT_THEME: ThemeMode = 'light';

  initialize(): void {
    this.applyTheme(this.getTheme());
  }

  getTheme(): ThemeMode {
    if (typeof localStorage === 'undefined') {
      return this.DEFAULT_THEME;
    }

    const storedTheme = localStorage.getItem(this.THEME_STORAGE_KEY);
    return storedTheme === 'dark' ? 'dark' : 'light';
  }

  setTheme(theme: ThemeMode): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(this.THEME_STORAGE_KEY, theme);
    }

    this.applyTheme(theme);
  }

  private applyTheme(theme: ThemeMode): void {
    const root = document.documentElement;

    root.classList.toggle('dark-theme', theme === 'dark');
    root.classList.toggle('light-theme', theme === 'light');
  }
}
